import { EventRecord } from "@/shared/domain/events";
import { legacyEventsWritable } from "@/shared/domain/orgs";
import { useOrgEventModel } from "@/shared/domain/orgs/hooks";

import { CreateDatasetEvent } from "./CreateDatasetEvent";
import { DeleteDatasetEvents } from "./DeleteDatasetEvents";

interface DatasetEventTableControlsProps {
  datasetId: string;
  resourceOwnerId: string;
  selectedEvents: EventRecord["event_id"][];
  onDeleteEvents: (events: EventRecord["event_id"][]) => void;
}

export function DatasetEventTableControls({
  datasetId,
  resourceOwnerId,
  selectedEvents,
  onDeleteEvents,
}: DatasetEventTableControlsProps) {
  // Hidden once the org's dataset events stop accepting writes (event model
  // `migrating` or `session`); shown while the org record loads.
  const eventModel = useOrgEventModel(resourceOwnerId);
  if (eventModel !== undefined && !legacyEventsWritable(eventModel)) {
    return null;
  }
  return (
    <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
      <CreateDatasetEvent datasetId={datasetId} />
      <DeleteDatasetEvents
        datasetId={datasetId}
        resourceOwnerId={resourceOwnerId}
        selectedEvents={selectedEvents}
        onDeleteEvents={onDeleteEvents}
      />
    </div>
  );
}
